import SectionHeading from "@/components/base/SectionHeading";
import { siteInfo } from "@/mocks/site";

type PrincipleGridProps = {
  kicker?: string;
  title?: string;
  desc?: string;
};

export default function PrincipleGrid({
  kicker = "内容原则",
  title = "吃瓜可以快，但不能糊",
  desc = "所有追踪都遵循同一套判断标准。下面四条不是口号，而是我们决定一条信息能不能写进时间线的依据。",
}: PrincipleGridProps) {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <SectionHeading kicker={kicker} title={title} desc={desc} />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {siteInfo.principles.map((item, index) => (
            <article
              key={item.title}
              className="flex h-full flex-col rounded-lg border border-background-300 bg-background-50 p-5"
            >
              <div className="mb-4 flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mb-2 font-heading text-base font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}